import { Component, OnInit, Input, ViewChild, ElementRef, OnDestroy, HostListener } from '@angular/core';
import { SearchService } from '../../services/search.service';
import { Estado, Ciudad } from '../../models/InmuebleSearch.model.response';
import { ContactarAgenteService } from '../../services/contactanos-detalle.service';
import { MotivoContacto, ContactarAgente } from '../../models/contactanosdetalle.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { AppConfig } from '../../AppConfig';
import { OpExitosaModalComponent } from '../op-exitosa-modal/op-exitosa-modal.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-contactanos-detalle',
  templateUrl: './contactanos-detalle.component.html',
  styleUrls: ['./contactanos-detalle.component.css'],
  standalone: false
})
export class ContactanosDetalleComponent implements OnInit {

  @ViewChild('modalContacto', { static: false }) modalContacto: ElementRef;
  @ViewChild('modalRespuesta', { static: false }) modalRespuesta: ElementRef;
  error: any;
  @Input() detalle: any;
  @Input() idTipoSolicitud: number;
  estados: Estado[] = [];
  ciudades: Ciudad[] = [];
  Todos: string;
  numeroInvalido = true;
  formContacto: FormGroup;
  showForm: boolean;
  informacionRotation: number = 0;
  estadoRotation: number = 0;
  openedSelect: string = '';
  public listo: boolean = true;
  public enviado = false;
  nombreFocused: boolean = false;
  configuracion: any = {
    titulo: 'Registro Correcto',
    mensaje: 'Un agente se pondrá en contacto contigo',
    icono: 'fa fa-check-circle',
    color: 'text-success'
  }
  motivoContactos: MotivoContacto[] = [];
  public contacto: ContactarAgente = new ContactarAgente();
  constructor(private searchService: SearchService,
    private contactarAgenteServ: ContactarAgenteService,
    private date: DatePipe,
    private dialog: MatDialog
  ) {
    this.obtenerEstados();
    this.obtenerMotivosContacto();

  }

  ngOnInit() {

    this.iniciarFormulario();

    this.contacto.idPrefContacto = 1;
    this.contacto.idEstado = null;
  }
  toggleSelect(field: string) {
    const wasOpen = this.openedSelect === field;
    const previouslyOpened = this.openedSelect;

    if (wasOpen) {
      this.openedSelect = '';
      this.updateRotation(field);
    } else {
      if (previouslyOpened) this.updateRotation(previouslyOpened);
      this.openedSelect = field;
      this.updateRotation(field);
    }
  }
  updateRotation(field: string) {
    switch (field) {
      case 'motivoContactoEntity':
        this.informacionRotation -= 180;
        break;
      case 'estado':
        this.estadoRotation -= 180;
        break;
    }
  }

  public seleccionarMotivo(motivo: MotivoContacto): void {
    this.contacto.motivoContactoEntity = motivo;
    this.formContacto.get('motivoContactoEntity')?.setValue(motivo);
    this.toggleSelect('motivoContactoEntity');
  }
  public iniciarFormulario() {
    this.formContacto = new FormGroup({
      nombreCliente: new FormControl('', [Validators.required, this.nombreValido()]),
      apellido1: new FormControl('', [Validators.required, this.nombreValido()]),
      apellido2: new FormControl('', this.nombreValido()),
      correoECliente: new FormControl('', [Validators.required, Validators.email]),
      telCasaCliente: new FormControl('', [Validators.required, this.telefonoValido()]),
      telOficinaCliente: new FormControl('', this.telefonoValido()),
      idEstado: new FormControl(),
      idCiudad: new FormControl(),
      motivoContactoEntity: new FormControl('', Validators.required),
      idPrefContacto: new FormControl('', Validators.required), // Default: Correo
      comentarioCliente: new FormControl()
    });


    const preferencia = this.formContacto.get('idPrefContacto')?.value;

    if (preferencia === 1) {
      console.log('Eligió Teléfono');
    } else if (preferencia === 2) {
      console.log('Eligió Correo Electrónico');
    } else if (preferencia === 3) {
      console.log('Eligió Ambos');
    }

  }

  private nombreValido() {
    return (control: FormControl): { [key: string]: any } | null => {
      const valor: string = (control.value || '').trim();

      if (!valor) {
        return null;
      }

      if (valor.length < 2 || valor.length > 50) {
        return { longitud: true };
      }

      if (valor.length === 2 && valor[0].toLowerCase() === valor[1].toLowerCase()) {
        return { repetidos: true };
      }

      return null;
    };
  }

  private telefonoValido() {
    return (control: FormControl): { [key: string]: any } | null => {
      const valor: string = control.value;
      if (!valor) {
        return null;
      }

      const diezDigitos = /^\d{10}$/;

      const repetidos5 = /(.)\1{5,}/;

      if (repetidos5.test(valor)) {
        return { repetidos5: true };
      }

      if (!diezDigitos.test(valor)) {
        return { telefonoInvalido: true };
      }

      return null;
    };
  }


  public obtenerEstados(): void {
    this.searchService.obtenerEstados()
      .subscribe(response => this.estados = response.respuesta.estados);
  }

  public estadoSeleccionado(estado: number): void {
    //console.log(estado);
    if (estado) {
      this.searchService.obtenerCiudades({ idEstado: estado } as Estado)
        .subscribe(response => this.ciudades = response.respuesta.ciudades);
    }
  }

  public obtenerMotivosContacto(): void {
    this.motivoContactos = [];
    this.contactarAgenteServ.motivosContacto().subscribe(response => {
      this.motivoContactos = response;
    });
  }

  public isNumberKey(evt) {
    var charCode = (evt.which) ? evt.which : evt.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57))
      return false;
    return true;
  }

  soloLetras(event: KeyboardEvent): void {
    const key = event.key;

    const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]$/;

    if (!regex.test(key) &&
      key !== 'Backspace' &&
      key !== 'Tab' &&
      key !== 'ArrowLeft' &&
      key !== 'ArrowRight' &&
      key !== 'Delete') {
      event.preventDefault();
    }
  }

  public validarNumeros() {
    if (this.formContacto.get('telCasaCliente').value.length < 7 && this.formContacto.get('telOficinaCliente').value.length < 7) {
      this.numeroInvalido = false;
    } else {
      this.numeroInvalido = true;
    }
  }

  public guardarSolicitud(): void {
    if (this.formContacto.invalid) {
      this.validarNumeros();
      Object.values(this.formContacto.controls).forEach(control => {
        control.markAsTouched();
      });
      return;
    }

    if (this.enviado) {
      return;
    }
    this.enviado = true;

    console.log('Formulario:', this.formContacto.value);
    Object.assign(this.contacto, this.formContacto.value);

    console.log('Datos a guardar:', this.contacto);

    console.log('Detalle:', this.detalle);
    console.log('Promotor:', this.detalle.promotor);
    console.log('Gerente:', this.detalle.promotor.gerenteEntity);
    this.contacto.gerenteEntity.idGerente = this.detalle.promotor.gerenteEntity.idGerente;
    this.contacto.promotorEntity.idPromotor = this.detalle.promotor.idPromotor;
    this.contacto.idUsuario = 0;
    this.contacto.idStatusSolicitudDetalle = 1;
    this.contacto.idTipoSolicitud = this.idTipoSolicitud;
    this.contacto.idStatusSolicitud = 3;
    this.contacto.inmuebleEntity.idInmueble = this.detalle.inmueble.idInmueble;
    this.contacto.idDetalleStatus = 0;
    this.contacto.fechaCreacion = this.date.transform(new Date(), 'yyyy-MM-dd');
    this.contacto.fechaUltimaAct = this.date.transform(new Date(), 'yyyy-MM-dd');
    this.contacto.clienteEntity = null;
    console.log('Contacto:', this.contacto);


    if (this.contacto.idSolicitud == null) {
      this.contacto.idSolicitud = 0;
    }
    this.ciudades = [];
    this.contactarAgenteServ.guardarSolicitud(this.contacto).subscribe(response => {
      this.openModalExitoso(); // Modal exitoso actual
      this.formContacto.reset({
        nombreCliente: '',
        apellido1: '',
        apellido2: '',
        correoECliente: '',
        motivoContactoEntity: '',
        telCasaCliente: '',
        telOficinaCliente: '',
        idPrefContacto: '',
        idCiudad: null,
        idEstado: null,
        comentarioCliente: ''
      });
      this.contacto = new ContactarAgente();
      this.enviado = false;
    }, err => {
      this.modalRespuesta.nativeElement.click();
      this.configuracion = {
        titulo: 'Error al registrar',
        mensaje: 'Ha ocurrido un error.',
        icono: 'fa fa-times',
        color: 'text-primary'
      };
    });
  }
  
  openModalExitoso(): void {
    const dialogRef = this.dialog.open(OpExitosaModalComponent, {
      panelClass: 'modal-exitoso',
      autoFocus: false,
      disableClose: true
    });

    document.body.classList.add('disable-scroll');

    dialogRef.afterClosed().subscribe(() => {
      document.body.classList.remove('disable-scroll');
    });
  }

  public limpiar(): void {
    // Reiniciar modelo
    this.contacto = new ContactarAgente();
    this.contacto.idPrefContacto = 1; // Preferencia por defecto (si aplica)
    // Limpiar el formulario sin valores predeterminados
    this.formContacto.reset({
      nombreCliente: '',
      apellido1: '',
      apellido2: '',
      correoECliente: '',
      motivoContactoEntity: '', // vacío para evitar que se seleccione algo automáticamente
      telCasaCliente: '',
      telOficinaCliente: '',
      idPrefContacto: '',      // este sí tiene valor por defecto
      idCiudad: null,
      idEstado: null,
      comentarioCliente: ''
    });
    // Limpiar estado visual de validación
    this.formContacto.markAsPristine();
    this.formContacto.markAsUntouched();
    this.formContacto.updateValueAndValidity();
    // Limpiar estados de selectores personalizados
    this.estadoRotation = 0;
    this.informacionRotation = 0;
    this.openedSelect = '';
  }

  public cerrar() {
    this.limpiar();
  }
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const isInside = target.closest('.custom-select-wrapper');

    if (!isInside && this.openedSelect !== '') {
      const prev = this.openedSelect;
      this.openedSelect = '';
      this.updateRotation(prev);

      if (prev === 'motivoContactoEntity' && !this.contacto.motivoContactoEntity) {
        this.formContacto.get('motivoContactoEntity')?.setValue('');
      }

    }
  }

}
